import moment from "moment-timezone";
import { getSegmentKey, type SegmentOverride } from "./Temporary/Item/types";
import type { AvailabilitySegment } from "./Temporary/Item/segments";

// TODO: seed data so every request-change action (pending/active/closed/denied) has an
// example to look at - drop once these are driven by real submitted requests.
const buildDummyOverrides = () => {
    const today = moment();
    const submittedOverrides: Record<string, AvailabilitySegment[]> = {};
    const segmentOverrides: Record<string, SegmentOverride> = {};

    const addOverride = (dayKey: string, segment: AvailabilitySegment) => {
        submittedOverrides[dayKey] = [...(submittedOverrides[dayKey] || []), segment];
        return segment;
    };

    // Recurring tab: pending / active / closed examples (weekday keys are always visible).
    addOverride("recurring-monday", {
        isAvailable: false,
        allDay: true,
        reason: "Doctor appointment",
        periodFrom: today.clone().add(5, "days").format("YYYY-MM-DD"),
        periodTo: today.clone().add(7, "days").format("YYYY-MM-DD"),
    });
    addOverride("recurring-wednesday", {
        isAvailable: true,
        allDay: true,
        reason: "Covering a shift",
        periodFrom: today.clone().subtract(2, "days").format("YYYY-MM-DD"),
        periodTo: today.clone().add(2, "days").format("YYYY-MM-DD"),
    });
    addOverride("recurring-friday", {
        isAvailable: false,
        allDay: true,
        reason: "Vacation",
        periodFrom: today.clone().subtract(10, "days").format("YYYY-MM-DD"),
        periodTo: today.clone().subtract(3, "days").format("YYYY-MM-DD"),
    });

    // Temporary tab: same three statuses plus a denied example, all attached to today
    // so they're visible regardless of the selected date filter's exact range.
    const todayKey = today.format("YYYY-MM-DD");

    addOverride(todayKey, {
        isAvailable: false,
        allDay: true,
        reason: "Doctor appointment",
        periodFrom: today.clone().add(5, "days").format("YYYY-MM-DD"),
        periodTo: today.clone().add(7, "days").format("YYYY-MM-DD"),
    });
    addOverride(todayKey, {
        isAvailable: true,
        allDay: true,
        reason: "Covering a shift",
        periodFrom: today.clone().subtract(2, "days").format("YYYY-MM-DD"),
        periodTo: today.clone().add(2, "days").format("YYYY-MM-DD"),
    });
    const deniedSegment = addOverride(todayKey, {
        isAvailable: false,
        allDay: true,
        reason: "Personal errand",
        periodFrom: today.clone().subtract(10, "days").format("YYYY-MM-DD"),
        periodTo: today.clone().subtract(3, "days").format("YYYY-MM-DD"),
    });
    segmentOverrides[getSegmentKey(todayKey, deniedSegment)] = { status: "denied" };

    return { submittedOverrides, segmentOverrides };
};

export const { submittedOverrides: DUMMY_SUBMITTED_OVERRIDES, segmentOverrides: DUMMY_SEGMENT_OVERRIDES } = buildDummyOverrides();
